/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react'
import { useLocation, useHistory, RouteComponentProps } from 'react-router-dom'
import formatDateFns from 'date-fns/format';
import ptBr from 'date-fns/locale/pt-BR';
import { formatDate, formatGroupBy, formatMoney, formatDateHorsComDiaSemana } from '../../utils/format';
import {
  Button,
  Container,
  DivItems,
  FiltersContainer,
  LogoFooter,
  Main,
  RightButtons,
  Row,
} from './styles';
import LogoDevari from '../../assets/images/logo.png'
import ReactToPrint from 'react-to-print'
import { FaPlusSquare, FaMinusSquare } from 'react-icons/fa';
import { DivRow } from './styles';
import { useFormModal } from '../../contexts/formModal';
import Toast from '../../components/Toast';
import { getLicenseInfo } from '../../services/license';
import { addDays, format, isValid } from 'date-fns';
import ResumeFiltersReport from '../../components/ResumeFiltersReport';
import { VERSION } from '../../environment/stores';
import { getTitlesReport } from '../../services/titulos';
import { getBaixa, getItemsAndTitulos } from '../../services/pedidos';
import { convertToDate } from '../../utils/date';
import ptBR from 'date-fns/locale/pt-BR';
interface IReport {
  Cidade?: ICidade;
  Classe?: IClasse;
  UF?: IUf;
  atualizadoEm?: string;
  bairro?: string;
  cep?: string;
  codigo?: string;
  criadoEm?: string;
  endereco?: string;
  id?: string;
  inscricaoEstadual?: string;
  nome?: string;
  nomeFantasia?: string;
  numeroEndereco?: string;
  telefone?: string;
  celular?: string;
}

interface ICidade {
  id?: string;
  nome?: string;
}

interface IClasse {
  id?: string;
  nome?: string;
}

interface IUf {
  id?: string;
  nome?: string;
  codigo?: string;
}

interface IField {
  label: string;
  field: string;
  orderName?: string;
  right?: boolean;
}

interface Props extends RouteComponentProps {
  title: string;
  endpoint: string;
  filters: any;
  extraction?: any;
}

const ORDER_TYPE_COLORS: any = {
  'Não aprovado': 'red',
  'Aprovado': 'blue',
  'Baixa automática': 'orange',
  'Baixa não automática': 'gray',
  'Importação XML': 'yellow',
  'Cancelado': 'black',
};

const ORDER_TYPE_SHORT: any = {
  'Não aprovado': 'PDNA',
  'Aprovado': 'PDAP',
  'Baixa automática': 'PCBA',
  'Baixa não automática': 'PDBP',
  'Importação XML': 'PXML',
  'Cancelado': 'PDCA',
};

const ORDER_FIELD_PROVIDERS: IField[] = [
  { label: '', field: 'tipo' },
  { label: 'Pedido', field: 'chpedido' },
  { label: 'Título', field: 'chave' },
  { label: 'Tipo', field: 'TipoPedido' },
  { label: 'Pessoa', field: 'Pessoa' },
  { label: 'LE', field: 'LocEscritu' },
  { label: 'Estabelecimento', field: 'Estabelecimento' },
  { label: 'Número', field: 'numero' },
  { label: 'Classe', field: 'Classe' },
  { label: 'TP', field: 'TipoDocumento' },
  { label: 'Carteira', field: 'Carteira' },
  { label: 'Principal (R$)', field: 'valorPrincipal', right: true },
  { label: 'Corrigido (R$)', field: 'valorCorrigido', right: true },
  { label: 'Prazo', field: 'prazo' },
  { label: 'Atraso', field: 'atraso' },
  { label: 'Entrada', field: 'criadoEm' },
  { label: 'Vencimento', field: 'vencimento' },
  { label: 'Correção', field: 'correcao' },
  { label: 'Baixa', field: 'dtBaixa' },
  { label: 'Negociação', field: 'negociacao' },
]

const VehicleReport: React.FC<Props> = ({ title, endpoint, filters }) => {
  const location = useLocation<any>();
  const history = useHistory<any>();
  const { openModal } = useFormModal();
  const componentRef = useRef(null);
  const [reports, setReports] = useState<Array<IReport> | any>(null);
  const [marcaTexto, setMarcaTexto] = useState(false);
  const [gerarCabecalho, setGerarCabecalho] = useState(false);
  const [openList, setOpenList] = useState<Array<string>>([]);
  const [hasGroup, setHasGroup] = useState(false);
  const [fields, setFields] = useState<IField[]>(ORDER_FIELD_PROVIDERS)
  const [license, setLicense] = useState<any>(null);
  const [filterLabel, setFilterLabel] = useState<any>([])
  const [nivelArvore, setNivelArvore] = useState<number | null>(null);
  const [totPrincipal, setTotPrincipal] = useState("0,00");
  const [totCorrigido, setTotCorrigido] = useState("0,00");

  const date = new Date();

  useEffect(() => {
    getLicense();
  }, []);

  useEffect(() => {
    if (location.state) {
      const details = location.state.filtersToGet
      const _filterLabels = location.state.filtersLabels
      
      if (_filterLabels) {
        setFilterLabel(_filterLabels);
        let _newFields = [...fields];

        if(!_filterLabels.find((it:any) => (it.label === "Exibe CFOP" && it.value === 'SIM'))) {
          _newFields = _newFields.filter(it => it.field !== "cfop");
        }

        if(_filterLabels.find((it:any) => (it.label === "Chave Acesso NF" && it.value === "NÃO"))) {
          _newFields = _newFields.filter(it => it.field !== "chacessonf")
        }

        if(details.idApresentacaoLocEscritu && details.idApresentacaoLocEscritu === 'Não apresenta') {
          _newFields = _newFields.filter(it => it.field !== "LocEscritu")
        }

        if(details.idApresentacaoEstabelecimento && details.idApresentacaoEstabelecimento === 'Não apresenta') {
          _newFields = _newFields.filter(it => it.field !== "Estabelecimento")
        }

        setFields(_newFields)
      }
      
      if (details.marcaTexto) {
        setMarcaTexto(true)
        delete details.marcaTexto
      }
      if (details.gerarCabecalho) {
        setGerarCabecalho(true)
        delete details.gerarCabecalho
      }
      if (details.Agrupamento && details.Agrupamento.length) {
        setHasGroup(true);
        getReports(details, true);
        removeFields(details.Agrupamento);
      } else {
        getReports(details);
      }
      if(details.nivelEmArvore !== null) {
        setNivelArvore(details.nivelEmArvore);
      }

    }
  }, [])

  function removeFields(agrupamento:string[]) {
    let newFields = fields;
    
    agrupamento.map((ag) => {
      if(ag === "Recurso (Nome)" || ag === "Recurso (Código+Nome)" || ag === "Recurso" || ag === 'Recurso (Código)') {
        newFields = newFields.filter(field => field.label !== "Recurso");
      } else if(ag === 'Número do Documento') {
        newFields = newFields.filter(field => field.label !== "DOC");
      } else if(ag === 'Local de Escrituração') {
        newFields = newFields.filter(field => field.label !== "LE");
      } else {
        newFields = newFields.filter(field => field.label !== ag);
      }
      return null;
    });

    setFields(newFields);
  }

  async function getLicense() {
    try {
      const result = await getLicenseInfo();
      setLicense(result);
    } catch (error: any) {
      Toast.show(error, 'error');
    }
  }

  async function getReports(details: any, grouped:boolean = false) {
    let result;
    let countTotPrincipal: any = 0;
    let countTotCorrigido: any = 0;
    try {
      result = await getTitlesReport(details);
      if(grouped) {
        const formated = formatGroupBy(result);
        setReports(formated);
      } else {
        for (const item of result) {
          if (item.TipoPedido === 'Entrada') {
            if (item.valorPrincipal) countTotPrincipal -= item.valorPrincipal;
            if (item.valorCorrigido) countTotCorrigido -= item.valorCorrigido;
          } else if (item.TipoPedido === 'Saída') {
            if (item.valorPrincipal) countTotPrincipal += item.valorPrincipal;
            if (item.valorCorrigido) countTotCorrigido += item.valorCorrigido;
          }
        }
        countTotPrincipal = formatMoney(countTotPrincipal).replace("R$", "");
        countTotCorrigido = formatMoney(countTotCorrigido).replace("R$", "");
        setTotPrincipal(countTotPrincipal);
        setTotCorrigido(countTotCorrigido);
        setReports(result);
      }

    } catch (error) {
      console.error('Erro: ', error)
    }
  }

  const pageStyle = `
  @media print{
    html, body{
      border-collapse: collapse;
      height: initial !important;
      overflow: initial !important;
      print-color-adjust: exact;
      -webkit-print-color-adjust: exact;
    }
    table, th, td {
      border-collapse: collapse;
      white-space: normal;
    }
    .page-break {
      margin-top: 20px !important;
      display: block;
      page-break-before: auto;
    }

    div:nth-child(2) {
      height: auto;
    }
  }
  @page{
    margin: 20mm;
    size: auto;
  }
  `

  function checkIsOpen(item: any) {
    const _find = openList.find((op: any) => {
      if (op === item) {
        return true;
      }
      return false;
    });

    if (_find === null) {
      return true
    }

    return _find;
  }

  function handleOpen(item: any) {
    const _nome = item;
    const indexOf = openList.findIndex((it: any) => it === item);

    if (indexOf > -1) {
      const newList = [...openList];
      newList.splice(indexOf, 1);
      setOpenList(newList);
    } else {
      const newList = [...openList, _nome];
      setOpenList(newList);
    }
  }
  
  function _renderClassTr(item: any, identifier: number = 0, margin: number = 0): any {

    if (Array.isArray(item)) {
      return renderItemTable(item);
    } else {
      const _trs = Object.keys(item);
      if (_trs && _trs.length <= 0) {
        return (
          <tr>
            <td className="red-label" colSpan={fields.length}><b>Nenhum resultado para estas variáveis</b></td>
          </tr>
        )
      }
      return _trs.map((tr, index) => {
        const isOpen = nivelArvore !== null && nivelArvore <= margin ? true : checkIsOpen(`${tr}${identifier}`) ;
        let label: any = tr.split('-');
        if (label.length === 3 && label[0].length === 4 && label[1].length === 2 && label[2].length === 2) {
          const data = new Date(tr)
          
          if(isValid(data)){
            label = formatDateFns(addDays(data, 1), 'dd/MM/yy eeeeee', {
              locale: ptBr,
            });
          }
        } else {
          label = null;
        }
        return <>
          <tr className='button'>
            <td>
              <div onClick={() => handleOpen(`${tr}${identifier}`)} className='titleContainer'>
                <div className='plusBox' style={{ marginLeft: (margin) * 10 }}>
                  {isOpen ? <FaMinusSquare color='white' size={14} /> : <FaPlusSquare color='white' size={14} />}
                </div>
                <h4>{tr === 'null' ? ` ` : label ? label : tr}</h4>
              </div>
            </td>
            <td colSpan={fields.length - 1}></td>
          </tr>
          {isOpen ? _renderClassTr(item[tr], index, 1 + margin) : null}
        </>
      })
    }
  }

  async function loadPedido(chcriacao: number, baixaAutomatica?: boolean, baixaNaoAutomatica?: boolean) {
    try {
      const pedidos = await getBaixa(chcriacao, null);
      if (pedidos.length > 0) {
        const pedido = pedidos[0];
        const itemsTitulos = await getItemsAndTitulos([chcriacao]);
        const itemToSend = {
          ...pedido,
          items: itemsTitulos.items,
          titulos: itemsTitulos.titulos,
        };
        history.push({
          pathname: `/pedidos-de-entrada/resultado/editar/${itemToSend.id ? itemToSend.id : itemToSend.chcriacao}`,
          state: {
            item: itemToSend,
            baixaAutomatica,
            baixa: baixaNaoAutomatica,
          },
        });
      }
    } catch (err) {
      console.log(err);
    }
  }

  function renderItemTable (item: any) {
    const _listReport = hasGroup ? item[0] : item;
    if (_listReport && _listReport.length <= 0) {
      return (
        <tr>
          <td className="red-label" colSpan={fields.length}><b>Nenhum resultado para estas variáveis</b></td>
        </tr>
      )
    }
    return _listReport.map((it:any, idx:number) => {
      return <tr 
      key={idx}
      className={marcaTexto ? 'yellow' : ''}>
        {fields.map(field => {
          let value = it[field.field];
          if((field.field === 'valorPrincipal' || field.field === "valorCorrigido") && value) {
            value = formatMoney(value).replace("R$", "");
          }

          if(field.field === 'pedBaixado' || field.field === 'negociacao') {
            value = it[field.field] === true ? 'SIM' : 'NÃO';
          }

          if(field.field === 'chpedido') {
            if(it[field.field]) {
              return <td style={{
                color: 'blue',
                cursor: 'pointer'
              }}
              onClick={() => loadPedido(it[field.field], it["tipo"] === "Baixa automática", it["tipo"] === "Baixa não automática")}>
                {it[field.field]}
              </td>
            }
          }

          if (field.field === 'tipo') {
            return <td>
              <div style={{
                width: 25,
                height: 15,
                maxHeight: 15,
                maxWidth: 25, 
                fontSize: 10,
                textAlign: 'center',
                color: ORDER_TYPE_COLORS[it["tipo"]] === 'yellow' ? 'black' : 'white',
                backgroundColor: ORDER_TYPE_COLORS[it["tipo"]] || 'transparent',
                }}>{ORDER_TYPE_SHORT[it["tipo"]]}</div>
            </td>
          }

          
          if(field.field === 'numero') {
            return <td>{ORDER_TYPE_SHORT[it["tipo"]]} {it['chpedido']}</td>
          }

          if (field.field === 'prazo') {
            return <td>{it['prazo'] ? it['prazo'] : 0}</td>
          }
          
          if(field.field === 'vencimento' || field.field === 'criadoEm' || field.field === 'correcao' || field.field === 'dtBaixa') {
            if(it[field.field]){
              const emissao = it[field.field]
              const data = new Date(emissao)
              
              if(isValid(data)){
                value = formatDateFns(addDays(data, 1), 'dd/MM/yy eeeeee', {
                  locale: ptBr,
                });
              } else{
                value = ''
              }
            }
          }

          return <td style={{textAlign: field.right ? 'right' : 'left'}}>
            {value}
          </td>
        }
        )}
      </tr>
    })
  }

  function renderTable() {
    if(reports) {
      if (hasGroup) {
        return _renderClassTr(reports);
      }
      return renderItemTable(reports);
    } 
    return (
      <tr>
        <td className="red-label" colSpan={fields.length}><b>Nenhum resultado para estas variáveis</b></td>
      </tr>
    );
  }

  function handleOpenResumo() {
    let dtEmissao = convertToDate(date);
    let emissao = dtEmissao ? format(dtEmissao, 'dd/MM/yy eeeeee HH:mm', {
      locale: ptBR,
    }) : date;
    const copyFilters = [
      {
        label: 'Data',
        value: emissao,
      },
      {
        label: 'Versão do Sistema',
        value: VERSION,
      },
      {
        label: 'Caminho',
        value: 'Financeiro \\ Relatórios \\ Títulos',
      },
      ...filterLabel,
    ];
    openModal({
      title: `Resumo Variáveis`,
      children: () => <ResumeFiltersReport title={title} filters={copyFilters} />
    })
  }

  return (
    <Main>
      <Row>
        <Button onClick={() => history.goBack()}>Voltar</Button>
        <RightButtons>
          <Button onClick={handleOpenResumo}>Resumo</Button>
          <ReactToPrint
            trigger={() => {
              return <Button type='button' className='buttonPrint'>Imprimir</Button>
            }}
            content={() => componentRef.current}
            documentTitle="new document"
            pageStyle={pageStyle}
          />
        </RightButtons>
      </Row>

      <Container ref={componentRef}>
        <DivRow>
          {license && (
            <Row>
              <p>{license.nomeFantasia}</p>
              <label>Versão do Sistema: {VERSION}</label>
            </Row>
          )}
          <Row>
            <p>{title}</p>
            <label>{formatDateHorsComDiaSemana(date)}</label>
          </Row>
          <Row>
            <p>Financeiro \ Relatórios \ Títulos</p>
          </Row>
          {gerarCabecalho && (<FiltersContainer>
            <p className='title'>Filtros: </p>
            <p>
              {filterLabel.map((filter: any, index: any) => {
                let value = '';

                if (Array.isArray(filter.value)) {
                  if (filter.value.length === 0) value = 'Nenhum';
                  value = filter.value.map((it: any) => `${it} `);
                } else {
                  if (filter.value instanceof Date) {
                    value = formatDate(filter.value);
                  } else {
                    value = filter.value;
                  }
                }
                return (
                  <label className='label'>
                    {filter.label} - <span className='span'>{value}</span>
                  </label>
                )
              })}
            </p>
          </FiltersContainer>)}
        </DivRow>

        <DivItems>
          <table>
            <tr style={{ textAlign: 'left' }}>
              {fields.map((field) => <th
              key={field.field}>
                {field.label}
              </th>
              )}
            </tr>
            {renderTable()}
            <tr>
              <td><b>Total</b></td>
              <td colSpan={10}></td>
              <td style={{textAlign: 'right'}}>{totPrincipal}</td>
              <td style={{textAlign: 'right'}}>{totCorrigido}</td>
              <td colSpan={7}></td>
            </tr>
          </table>
        </DivItems>

        <LogoFooter>
          <img src={LogoDevari} alt="Logo Devari" />
        </LogoFooter>
      </Container>
    </Main>
  )
}

export default VehicleReport;